import getValidUseridService  from '../services/components/valid_userid.jsx'


const getState = (validUserIdState) => ({ type: "GET_VALIDUSERID", validUserIdState })


export const validateUserIdAction = (userid) => dispatch => {
    let state = [];

    getValidUseridService((data, msg) => {

        if (msg === "success") {

            state = {
                status: 200,
                body: data
            }
            
            localStorage.setItem("validUserId", JSON.stringify(state))
        } else {
            state = data
        }
        dispatch(getState(state))
    }, userid)
} 


// WEBPACK FOOTER //
// ./src/actions/validateUserIdAction.jsx